import { render, staticRenderFns } from "./ViewCompanyRegistry.vue?vue&type=template&id=81bf7e0e&"
import script from "./ViewCompanyRegistry.vue?vue&type=script&lang=js&"
export * from "./ViewCompanyRegistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports